import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M24.402 2c-.5 0-.902.398-1 .898L22.098 11H20c-1.102 0-2 .898-2 2v2h14v-2c0-1.102-.898-2-2-2h-2.098l-1.304-8.102c-.098-.5-.5-.898-1-.898ZM19 17c-2.2 0-4 1.8-4 4v24c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V21c0-2.2-1.8-4-4-4Z" }, null, -1)
  ])))
}
export default { render: render }